import { CurrencyPicker, TextInput } from "components/core";
import { FormikProps } from "formik";
import { FC } from "react";

export interface UpdateTargetFormValues {
  name: string;
  targetId: string;
  start_date: string;
  end_date: string;
  base_currency: string;
}

export interface UpdateTargetFormProps {
  form: FormikProps<UpdateTargetFormValues>;
}

const UpdateTargetForm: FC<UpdateTargetFormProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <TextInput
        id="name"
        label="Target Name"
        type="text"
        placeholder="Enter target name"
        required={true}
        values={form.values}
        handleChange={form.handleChange}
        handleBlur={form.handleBlur}
        errors={form.errors}
        touched={form.touched}
      />
      <TextInput
        id="start_date"
        label="Start Date"
        type="date"
        required={true}
        values={form.values}
        handleChange={form.handleChange}
        handleBlur={form.handleBlur}
        errors={form.errors}
        touched={form.touched}
      />
      <TextInput
        id="end_date"
        label="End Date"
        type="date"
        required={true}
        values={form.values}
        handleChange={form.handleChange}
        handleBlur={form.handleBlur}
        errors={form.errors}
        touched={form.touched}
      />
      <CurrencyPicker
        id="base_currency"
        label="Base Currency"
        placeholder="Select currency"
        required={true}
        values={form.values}
        errors={form.errors}
        touched={form.touched}
        setFieldValue={form.setFieldValue}
        setFieldTouched={form.setFieldTouched}
        setFieldError={form.setFieldError}
      />
    </div>
  );
};

export default UpdateTargetForm;
